import { useTranslation } from 'react-i18next';

import { SigningProgressInformationAttachmentsState } from '@app/store/signingProgressInformation/reducers/attachments';

import './AttachmentsInfo.scss';

interface AttachmentsInfoProps {
  attachments: SigningProgressInformationAttachmentsState;
  isSigningInOrder: boolean;
}

function AttachmentsInfo({ attachments, isSigningInOrder }: AttachmentsInfoProps) {
  const { t } = useTranslation();

  return (
    <div className="box-5x">
      <h5 className="space-3x">{t('AttachmentsInfo-title')}</h5>
      {attachments.map((attachment) => (
        <div key={attachment.participantId}>
          <p className="space-1x">
            <b>
              {isSigningInOrder && `${attachment.participantSigningOrder}.`}
              {attachment.participantName} ({attachment.participantContactInfo})
            </b>
          </p>
          <table className="InfoTable">
            <tbody>
              {attachment.attachments.map((participantAttachment) => (
                <tr key={participantAttachment.attachmentType}>
                  <th className="InfoTable__label-cell AttachmentsInfo__label-cell">
                    {participantAttachment.attachmentType}
                  </th>
                  <td className="InfoTable__value-cell InfoTable__value-cell--light">
                    {participantAttachment.fileName}
                    {participantAttachment.fileExtension}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}
    </div>
  );
}

export default AttachmentsInfo;
